import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import GoBack from "../../../component/molecules/goBack";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import MainInput from "../../../component/atoms/input/mainInput";
import Radio from "../../../component/atoms/input/radio";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import CommunityApi from "../../../api/community.api";

function CommunityCategoryEdit() {
  // import
  const navigate = useNavigate();
  let { id } = useParams();

  // mounted
  useEffect(() => {
    getCategoryInfo();
  }, []);

  // ----- 정보 가져오기
  const [categoryInfo, setCategoryInfo] = useState({
    activation: "",
    title: "",
    postCount: "",
  });

  const getCategoryInfo = async () => {
    try {
      const response = (await CommunityApi.getCategoryById(id)).data.data
        .content;

      setCategoryInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveFunc = async () => {
    try {
      await CommunityApi.editCategory(id, {
        title: categoryInfo.title.trim(),
        activation: categoryInfo.activation,
      });
      setSaveModalOpen(false);
      navigate(-1);
      toast(toastMsg.create);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>수정하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={"true"}
                    name={"activation"}
                    valueText={"활성"}
                    checked={categoryInfo.activation}
                    onChange={() => {
                      setCategoryInfo({
                        ...categoryInfo,
                        activation: true,
                      });
                    }}
                  />
                  <Radio
                    id={"false"}
                    name={"activation"}
                    valueText={"비활성"}
                    checked={!categoryInfo.activation}
                    onChange={() => {
                      setCategoryInfo({
                        ...categoryInfo,
                        activation: false,
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>카테고리명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"카테고리명을 입력해주세요"}
                  value={categoryInfo.title}
                  onChange={(e) =>
                    setCategoryInfo({ ...categoryInfo, title: e.target.value })
                  }
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>게시글 수</DetailFormTitle>
                <DetailFormText>{categoryInfo.postCount}</DetailFormText>
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  if (!categoryInfo.title.trim()) {
                    return toast("카테고리명을 입력해주세요.");
                  }

                  setSaveModalOpen(true);
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : null}
    </>
  );
}

export default CommunityCategoryEdit;
